import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { PromotionsIcon } from 'src/domains/layouts/shared/assets/icons/PromotionsIcon';
import { withConfig } from 'src/withConfig';

interface RaceBannerPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceBanner = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 8px 8px 0;
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css``;
};

export const RaceBanner = withConfig(theme => styled('div', { label: 'RaceBanner' })<RaceBannerPropsType>`
    ${({ variant }): SerializedStyles=> setRaceBanner(variant, theme)};
    align-items: center;
    background-color: ${theme.star.raceCard.inProgress.bgColor};
    color: ${theme.star.raceCard.inProgress.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 8px;
    justify-content: center;
    line-height: 1.3334;
    padding: 16px;
    position: relative;
`);

export const MegaphoneIcon = styled(PromotionsIcon, { label: 'MegaphoneIcon' })`
    fill: currentcolor;
    width: 24px;
`;

interface FilterContainerPropsType {
    variant: DefaultComponentVariantType | null;
}

export const FilterContainer = withConfig(theme => styled('div', { label: 'FilterContainer' })<FilterContainerPropsType>`
    align-items: center;
    background-color: ${theme.star.raceCard.filters.type.bgColor};
    border-style: solid;
    border-width: 1px 0 0 0;
    border-color: ${theme.star.raceCard.filters.type.borderColor};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? `${theme.star.padding.medium}` : `${theme.star.padding.medium} 0 ${theme.star.padding.medium} ${theme.star.padding.medium}`};
`);
